// extracted by mini-css-extract-plugin
export default {"leaseFeesEditorContainer":"_lease-fees-editor_leaseFeesEditorContainer__tP2LE"};